import { useSelector } from 'react-redux';
import { logError } from 'hx-analytics/src/functions/logging/log-error.helper';
export function useTestCompletionCallback() {
    var _a = useSelector(function (state) { return state; }), dinTest = _a.dinTest, wizard = _a.wizard;
    function handleTestCompletion() {
        var _a, _b, _c, _d, _e, _f;
        var firstName = (_a = wizard.form) === null || _a === void 0 ? void 0 : _a['first-name'];
        var lastName = (_b = wizard.form) === null || _b === void 0 ? void 0 : _b['last-name'];
        var birthYear = (_c = wizard.form) === null || _c === void 0 ? void 0 : _c['birth-year'];
        var email = (_d = wizard.form) === null || _d === void 0 ? void 0 : _d['email'];
        var isValidForm = isString(firstName) && isString(lastName) && isString(email) && isNumber(birthYear);
        var hasCategory = !!((_e = dinTest.result) === null || _e === void 0 ? void 0 : _e.category);
        if (!isValidForm || !hasCategory) {
            logError({
                error: !isValidForm ? 'Missing/invalid user data' : 'Missing hearing category',
                message: 'Failed to trigger test complete postMessage',
                tag: { name: 'test-complete', value: 'missing data' },
                metadata: { dinTest: dinTest, wizard: wizard },
                level: 'error',
            });
            return;
        }
        var testData = {
            date: new Date().toJSON(),
            first_name: firstName,
            last_name: lastName,
            email_address: email,
            birth_year: birthYear,
            signal_to_noise_ratio: dinTest.result.averageSnr,
            result_category: dinTest.result.category,
        };
        (_f = window.parent) === null || _f === void 0 ? void 0 : _f.postMessage({ type: 'host/test-complete', payload: testData }, '*');
    }
    return handleTestCompletion;
}
function isString(value) {
    return typeof value === 'string';
}
function isNumber(value) {
    return typeof value === 'number' && !Number.isNaN(value);
}
